import Button from 'antd/lib/button';
import Radio from 'antd/lib/radio';
import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { QuoteType } from '../../../SE.interfaces';
import SEQuoteCard from '../../../SEActions/SETasks/SEQuoteCard';
import { SEQuotesStyles } from './SEQuotes.styles';

const styles = () => ({ ...SEQuotesStyles() });

interface SEQuotesProps extends StylesProps<ReturnType<typeof styles>> {
  selectedQuote?: QuoteType;
  quoteList?: QuoteType[];
  onQuoteSelection: (quote: QuoteType) => void;
  resetQuote: () => void;
  disabled?: boolean;
  /** ISS-292834 — vendor's Select-Vendor-Types sub-fields (rank bar) + shipment-level match factors (shown once). */
  vendorSelectionFields?: { label: string; value: string }[];
  shipmentMatchFactors?: { label: string; value: string }[];
}

const SEQuotes: React.FC<SEQuotesProps> = ({
  classes, selectedQuote, quoteList, onQuoteSelection, resetQuote, disabled, vendorSelectionFields, shipmentMatchFactors,
}) => {
  if (!quoteList?.length) {
    return <div className={classes.noQuote}>There is no quote available.</div>;
  }

  const renderChangeSelection = () => (
    !disabled && selectedQuote && (
      <div className={classes.changeSelection}>
        <Button type="link" className={classes.clearSelectionButton} onClick={resetQuote}>
          Clear selection
        </Button>
      </div>
    )
  );

  return (
    <>
      <Radio.Group
        className={classes.radioGroup}
        onChange={(e) => {
          const quote = quoteList.find((q) => q.bidId === e.target.value);
          if (quote) onQuoteSelection(quote);
        }}
        value={selectedQuote?.bidId}
        disabled={disabled}
      >
        {quoteList.map((quote) => (
          // Reference-only cards (non-spot L1 for spot shipments) are shown for context, not selectable.
          <Radio
            className={classes.radio}
            value={quote.bidId}
            key={quote.bidId}
            disabled={disabled || quote.isReferenceOnly}
          >
            <SEQuoteCard
              quote={quote}
              deviationFromL1={quote.deviationFromL1}
              vendorSelectionFields={vendorSelectionFields}
              shipmentMatchFactors={shipmentMatchFactors}
              isSelected={quote.bidId === selectedQuote?.bidId}
              disabled={disabled}
            />
          </Radio>
        ))}
      </Radio.Group>
      {renderChangeSelection()}
    </>
  );
};

export default withStyles(styles)(SEQuotes);
